var map = {
	"./Zdoro.jpg": 8659,
	"./akspa.jpg": 8214,
	"./cert1.jpg": 3131,
	"./certspa.jpg": 503,
	"./Боди лайн.jpg": 2679,
	"./Девичник.jpg": 9137,
	"./Для неё.jpg": 4883,
	"./Зимний.jpg": 4754,
	"./Кокосовй рай.jpg": 3068,
	"./Леди СПА.jpg": 8401,
	"./Медовый.jpg": 1641,
	"./Остров здоровья.jpg": 7668,
	"./Полное очищение.jpg": 4112,
	"./Сияй.jpg": 4307,
	"./Султан.jpg": 9485,
	"./Счастливая семья.jpg": 9817,
	"./Ты и я.jpg": 5288,
	"./Удовольствие.jpg": 204,
	"./Цитрусовая эйфория.jpg": 9996,
	"./Шоколадная королева.jpg": 2807
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 274;